<p-button
appPreventDoubleClick
styleClass="p-button-outlined"
icon="fa fa-pen"
id="editDocumentButton"
class="edit-document-button"
pTooltip="Edit Properties"
tooltipPosition="left"
iconPos="left"
(debounceClick)="editDocument()"
></p-button>